export function ApiResponse(Success, Message, IsAuthFailure, Data, TotalRecord) {
  return {
    success: Success,
    message: Message,
    status_code: '',
    IsAuthFailure: IsAuthFailure,
    data: Data,
    total: 0,
    page: 0,
    limit: 0,
    search: "",
    orderby: ""
  };
}